<!--
 * @Author: xwc
 * @Date: 2020-07-29 10:39:26
 * @LastEditors: xwc
 * @LastEditTime: 2020-08-31 09:03:54
 * @FilePath: \jdy\src\views\Home.vue
-->
<template>
  <div class="home">
    <img alt="Vue logo" src="@/assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  }
}
</script>
